import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import '@/styles/Characters/InlineEditField.css';
import { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
const InlineEditSelect = ({ name, value, options, placeholder, onChange, isDisabled, classNamePrefix = 'react-select', className, }) => {
    const [editing, setEditing] = useState(false);
    const containerRef = useRef(null);
    const selectedOption = options.find((o) => o.value === value) || null;
    useEffect(() => {
        function handleClickOutside(e) {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setEditing(false);
            }
        }
        if (editing) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [editing]);
    const handleSelectChange = (opt) => {
        const val = (opt === null || opt === void 0 ? void 0 : opt.value) || '';
        onChange(val);
        setEditing(false); // закрываем после выбора
    };
    if (editing && !isDisabled) {
        return (_jsx("div", { ref: containerRef, className: `inline-edit-select-wrapper ${className || ''}`, onMouseDown: (e) => e.stopPropagation(), children: _jsx(Select, { name: name, options: options, value: selectedOption, onChange: handleSelectChange, placeholder: placeholder, isSearchable: false, classNamePrefix: classNamePrefix, onBlur: () => setEditing(false), onMenuClose: () => setEditing(false) }) }));
    }
    return (_jsx("span", { className: `inline-edit-display ${className || ''}`, role: "button", tabIndex: 0, "aria-label": placeholder, onClick: isDisabled
            ? undefined
            : (e) => {
                e.stopPropagation();
                setEditing(true);
            }, onKeyDown: (e) => {
            if (isDisabled)
                return;
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setEditing(true);
            }
        }, children: selectedOption ? (_jsx(_Fragment, { children: selectedOption.label })) : (_jsx("span", { className: "inline-edit-placeholder", children: placeholder })) }));
};
export default InlineEditSelect;
